export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';
export const FETCH_ORDERS_RESET = 'FETCH_ORDERS_RESET';
// Fetch data actions
export const fetchOrdersRequest = (payload) => ({
    type: FETCH_ORDERS_REQUEST,
    payload,
});
export const fetchOrdersSuccess = (payload) => ({
    type: FETCH_ORDERS_SUCCESS,
    payload,
});
export const fetchOrdersFailure = (error) => ({
    type: FETCH_ORDERS_FAILURE,
    payload: error,
});
export const fetchOrdersReset = () => ({
    type: FETCH_ORDERS_RESET,
});
